import { Injectable } from '@angular/core';

import {  HttpGeneralService } from '../../shared/shared';
import { CONFIG } from '../../shared/config';

let familyDetailUrl = CONFIG.baseUrls.familyDetail;

export interface FamilyDetail {

    serial: number;
    relationDegree: number;
    parentId: number; 
    patientCode: number;
    rowStatus:number;
    patientNameAr: string;
    patientNameEn: string;
    relativeNameAr: string;
    relativeNameEn: string;
    fullnameAr:string;
    fullnameEn:string;
}

@Injectable()
export class FamilyDetailService {

    constructor(private httpGeneralService: HttpGeneralService) { }


    getfamilyDetail(serial: number) {
        return this.httpGeneralService.get(serial, familyDetailUrl)

    
    }

    deleteFamilyDetail(serial:number){
        return this.httpGeneralService.delete(serial,familyDetailUrl);
    }


}